module.exports = __webpack_public_path__ + "static/media/astrid_levelup_wordrace.9c6a4274.png";